import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=0dbb0186&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=ts&"
export * from "./tabList.vue?vue&type=script&lang=ts&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=0dbb0186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb0186",
  null
  
)

export default component.exports